import request from '@/utils/request'
import { apiConsolelog } from '@/utils/tracelog'

export function getTermsOfUse (textSize) {
  apiConsolelog('api: getTermsOfUse(): textSize = %s', textSize)

  return request({
    url: '/terms-of-use/show',
    method: 'get',
    text_size: textSize
  })
}
